import { getStatColor, formatStatValue } from '../balancing.utils';

type Props = {
  label: string;
  value: number;
  className?: string;
};

export function StatBadge({ label, value, className = '' }: Props) {
  return (
    <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-lg ${getStatColor(value)} ${className}`}>
      <span className="text-sm font-medium">{label}</span>
      <span className="text-sm font-bold">{formatStatValue(value)}</span>
    </div>
  );
}
